module.exports = __webpack_public_path__ + "img/emoji_46.bdd13b47.png";